export default class SalesRecordingsClient {
    constructor(apiClient) {
        this.baseURI = '/v3/sales_recordings';
        this.baseURISearch = '/v3/sales_recording_searches';
        this.apiClient = apiClient;
        this.postSalesRecordingsExport = this.postSalesRecordingsExport.bind(this);
        this.putSalesRecording = this.putSalesRecording.bind(this);
        this.putSalesRecordingDocument = this.putSalesRecordingDocument.bind(this);
        this.putSalesRecordingStatus = this.putSalesRecordingStatus.bind(this);
        this.deleteSalesRecording = this.deleteSalesRecording.bind(this);
        this.deleteSalesRecordingDocument = this.deleteSalesRecordingDocument.bind(this);
        this.getSalesRecordings = this.getSalesRecordings.bind(this);
        this.getSalesRecording = this.getSalesRecording.bind(this);
        this.getSalesRecordingVersion = this.getSalesRecordingVersion.bind(this);
        this.getSalesRecordingVersions = this.getSalesRecordingVersions.bind(this);
        this.postSalesRecording = this.postSalesRecording.bind(this);
        this.postSalesRecordingSearch = this.postSalesRecordingSearch.bind(this);
    }
    postSalesRecordingsExport(data, config) {
        return this.apiClient.post(`${this.baseURI}/export`, data, config);
    }
    putSalesRecording(id, data, config) {
        return this.apiClient.put(`${this.baseURI}/${id}`, data, config);
    }
    putSalesRecordingDocument(id, data, config) {
        return this.apiClient.put(`${this.baseURI}/${id}/documents`, data, config);
    }
    putSalesRecordingStatus(id, data, config) {
        return this.apiClient.put(`${this.baseURI}/${id}/status`, data, config);
    }
    deleteSalesRecording(id, config) {
        return this.apiClient.delete(`${this.baseURI}/${id}`, config);
    }
    deleteSalesRecordingDocument(id, config) {
        return this.apiClient.delete(`${this.baseURI}/${id}/documents`, config);
    }
    getSalesRecordings(config) {
        return this.apiClient.get(this.baseURI, config);
    }
    getSalesRecording(id, config) {
        return this.apiClient.get(`${this.baseURI}/${id}`, config);
    }
    getSalesRecordingVersion(id, updateId, config) {
        return this.apiClient.get(`${this.baseURI}/${id}/versions/${updateId}`, config);
    }
    getSalesRecordingVersions(id, config) {
        return this.apiClient.get(`${this.baseURI}/${id}/versions`, config);
    }
    postSalesRecording(data, config) {
        return this.apiClient.post(this.baseURI, data, config);
    }
    postSalesRecordingSearch(data, config) {
        return this.apiClient.post(this.baseURISearch, data, config);
    }
}
